/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_79fdec12"]'><div><div :class='["picker-demo-title"]'>time-picker:</div><cube-date-picker ref="__mpx_ref_picker__" :min="(min)" :max="(max)" :value="(value)" :startColumn="(startColumn)" @change='(e)=>__invoke(e, [["onChange"]])'/><div :class='["demo-data"]' v-if="(changeParams)"><div :class='["value"]'><div v-for="(item, index) in (changeParams)" :key="item.index" :class='["value-item"]'><div :class='["item-key"]'>{{item[0]}}</div><div :class='["item-value"]'>{{item[1]}}</div></div></div></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_79fdec12"}'>
.picker-demo-title
  margin-bottom: 8px
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_79fdec12"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_79fdec12"}
  /** script content **/
  require("./time-picker.mpx.js?isComponent&outputPath=components%2Ftime-picker79fdec12%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./time-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftime-picker79fdec12%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_79fdec12"],
    ctorType: "component",
    outputPath: "components/time-picker79fdec12/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker/index.mpx?isComponent&outputPath=components%2Findexc2f4660c%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>